import React, { useState } from 'react';
import Topbar from '../components/Topbar';
import { CheckCircle, MessageSquare, TrendingUp } from 'lucide-react';
import './ActivityPage.css';

interface ActivityItem {
  id: string;
  tipo: 'votacao' | 'movimento' | 'parecer';
  titulo: string;
  descricao: string;
  proposicao: string;
  data: string;
  icon: 'check' | 'message' | 'trending';
}

const mockActivities: ActivityItem[] = [];

export default function ActivityPage() {
  const [filtro, setFiltro] = useState<'todas' | 'votacao' | 'movimento' | 'parecer'>('todas');

  const filtered =
    filtro === 'todas'
      ? mockActivities
      : mockActivities.filter((a) => a.tipo === filtro);

  const getIcon = (icon: string) => {
    switch (icon) {
      case 'check':
        return <CheckCircle size={20} className="activity-icon votacao" />;
      case 'message':
        return <MessageSquare size={20} className="activity-icon parecer" />;
      case 'trending':
        return <TrendingUp size={20} className="activity-icon movimento" />;
      default:
        return null;
    }
  };

  return (
    <div className="activity-container">
      <Topbar title="Atividade" badge="mocks" />
      <div className="activity-content">
        <div className="activity-filters">
          {(['todas', 'votacao', 'movimento', 'parecer'] as const).map((f) => (
            <button
              key={f}
              className={`filter-btn ${filtro === f ? 'active' : ''}`}
              onClick={() => setFiltro(f)}
            >
              {f === 'todas' ? 'Tudo' : f === 'votacao' ? 'Votações' : f === 'movimento' ? 'Movimentos' : 'Pareceres'}
            </button>
          ))}
        </div>

        <div className="activity-list">
          {filtered.map((activity) => (
            <div key={activity.id} className="activity-item">
              <div className="activity-item-icon">{getIcon(activity.icon)}</div>
              <div className="activity-item-content">
                <div className="activity-item-title">{activity.titulo}</div>
                <div className="activity-item-description">{activity.descricao}</div>
                <div className="activity-item-meta">
                  <span className="activity-badge">{activity.proposicao}</span>
                  <span className="activity-date">{new Date(activity.data).toLocaleDateString('pt-BR')}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
